import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { ContactsTabsDesktop } from "./desktop";
import { ContactsTabsMobile } from "./mobile";

export const ContactsTabs = () => {
  return (
    <div>
      <ResponsiveBlockSwitcher desktop={<ContactsTabsDesktop />} mobile={<ContactsTabsMobile />} />
    </div>
  );
};
